import { MenuItem } from "../menu-item/menu-item.interface";

export const getDataFromElements = (el: HTMLO2MenuElement): MenuItem[] => {
  const menuItems = Array.from(el.querySelectorAll('o2-menu-item'));

  return mapElementsToData(menuItems)
};

export const mapElementsToData = (menuItems: HTMLO2MenuItemElement[]): MenuItem[] => {
  return menuItems.map((menuItem: HTMLO2MenuItemElement) => ({
    value: menuItem.getAttribute('value') || '',
    text: menuItem.getAttribute('text') || menuItem.textContent.trim(),
    selected: menuItem.hasAttribute('selected') || false,
    disabled: menuItem.hasAttribute('disabled') || false,
  }));
}

export const getSelectedFromElements = (el: HTMLO2MenuElement): MenuItem[] => {
  const menuItems = Array.from(el.querySelectorAll('o2-menu-item'));
  const filtered = menuItems.filter((menuItem: HTMLO2MenuItemElement) => menuItem.hasAttribute('selected'));
  return mapElementsToData(filtered);
}

export const removeSelectedFromElements = (el: HTMLO2MenuElement, value: string) => {
  const foundMenuItem = findMenuItemFromElements(el, value);

  if (foundMenuItem) {
    foundMenuItem.removeAttribute('selected');
  }
}

export const setSelectedFromElements = (el: HTMLO2MenuElement, value: string) => {
  const foundMenuItem = findMenuItemFromElements(el, value);

  if (foundMenuItem) {
    foundMenuItem.setAttribute('selected', '');
  }
}

export const toggleSelectedFromElements = (el: HTMLO2MenuElement, value: string) => {
  const foundMenuItem = findMenuItemFromElements(el, value);

  if (foundMenuItem && foundMenuItem.hasAttribute('selected')) {
    foundMenuItem.removeAttribute('selected');
  } else {
    foundMenuItem.setAttribute('selected', '');
  }
}

export const deselectAllFromElements = (el: HTMLO2MenuElement) => {
  const menuItems = Array.from(el.querySelectorAll('o2-menu-item'));

  menuItems.forEach((menuItem: HTMLO2MenuItemElement) => {
    menuItem.removeAttribute('selected');
  });
}

const findMenuItemFromElements = (el: HTMLO2MenuElement, value: string) => {
  return el.querySelector(`o2-menu-item[value="${value}"]`);
}
